import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {  fetchJobs } from '../../api'; // Import from api.js


// Async thunk for fetching dashboard data
export const fetchJobsData = createAsyncThunk(
  'jobs',
  async (_, { rejectWithValue }) => {
    try {
      // Use the function from api.js
      const data = await fetchJobs();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch dashboard data');
    }
  }
);

const jobsSlice = createSlice({
  name: 'jobs',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobsData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchJobsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError } = jobsSlice.actions;
export default jobsSlice.reducer;
